import { library, dom } from '@fortawesome/fontawesome-svg-core';

import { faWindows, faApple } from '@fortawesome/free-brands-svg-icons';
import {
	faBars,
	faSignOut,
	faPlus,
	faArrowLeft,
	faArrowRight,
	faSearch,
	faCalendarAlt,
	faClone,
	faEllipsisH,
	faCheckCircle,
	faExclamationCircle,
	faSpinner,
	faCommentAltDots,
	faLongArrowRight,
	faTrashAlt,
	faPrint,
	faFileInvoice,
	faAngleLeft,
	faAngleRight,
	faAngleUp,
	faAngleDown,
	faBoxArchive,
	faCopy,
	faUpload,
	faHistory,
	faComment,
	faEdit,
	faTrash,
	faSave,
	faRandom,
	faEye,
	faExclamationTriangle,
	faTimes as faTimesRegular,
	faChartLine,
	faStopwatch,
	faCheck,
	faInfoCircle,
	faFileAlt,
	faSyncAlt,
	faMapMarkerAlt,
	faFileCsv,
	faChartBar,
	faQuestionCircle,
	faArrowsAltH,
	faClock as faClockRegular,
	faKey,
	faSync,
} from '@fortawesome/pro-regular-svg-icons';

import { faTimes } from '@fortawesome/pro-light-svg-icons';

import {
	faCircleCheck,
	faCircleXmark,
	faGear,
	faEnvelope,
	faCircle,
	faDownload,
	faSort,
	faSortUp,
	faSortDown,
	faFilter,
	faServer,
	faClock,
	faCheckCircle as faCheckCircleSolid,
	faCogs,
	faArrowsH,
	faDatabase,
	faBolt,
	faExpandAlt,
	faCompressAlt,
	faChevronDown,
	faChartArea,
	faRedo,
	faPlusCircle,
	faPercent,
	faUsers,
	faPlayCircle,
	faVolumeUp,
} from '@fortawesome/pro-solid-svg-icons';

library.add(
	faBars,
	faSignOut,
	faPlus,
	faArrowLeft,
	faArrowRight,
	faSearch,
	faCalendarAlt,
	faClone,
	faTimes,
	faEllipsisH,
	faCheckCircle,
	faSpinner,
	faCommentAltDots,
	faLongArrowRight,
	faTrashAlt,
	faPrint,
	faFileInvoice,
	faAngleLeft,
	faAngleRight,
	faAngleUp,
	faAngleDown,
	faBoxArchive,
	faCopy,
	faWindows,
	faApple,
	faUpload,
	faHistory,
	faComment,
	faExclamationCircle,
	faCircleCheck,
	faCircleXmark,
	faGear,
	faEnvelope,
	faEdit,
	faCircle,
	faDownload,
	faSort,
	faSortUp,
	faSortDown,
	faFilter,
	faTrash,
	faSave,
	faRandom,
	faEye,
	faExclamationTriangle,
	faTimesRegular,
	faChartLine,
	faStopwatch,
	faCheck,
	faServer,
	faClock,
	faCheckCircleSolid,
	faCogs,
	faArrowsH,
	faInfoCircle,
	faDatabase,
	faBolt,
	faExpandAlt,
	faCompressAlt,
	faChevronDown,
	faChartArea,
	faRedo,
	faPlusCircle,
	faFileAlt,
	faMapMarkerAlt,
	faSyncAlt,
	faFileCsv,
	faChartBar,
	faQuestionCircle,
	faArrowsAltH,
	faClockRegular,
	faPercent,
	faKey,
	faSync,
	faUsers,
	faPlayCircle,
	faVolumeUp
);

dom.watch();
